var _rect, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUrbanAgent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 60,
    viewBox: "0 0 60 60",
    width: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#161616",
    height: 60,
    rx: 20,
    width: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.6465 43.6463 29.0172-29.0172",
    stroke: "#fff",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.6 26.056c-1.5787 0-2.9067-.512-3.984-1.536s-1.616-2.3573-1.616-4 .5387-2.9707 1.616-3.984c1.0773-1.024 2.4053-1.536 3.984-1.536 1.8347 0 3.2693.7413 4.304 2.224l-1.536.864c-.2987-.416-.6933-.7573-1.184-1.024-.48-.2667-1.008-.4-1.584-.4-1.056 0-1.936.3627-2.64 1.088-.6933.7253-1.04 1.648-1.04 2.768s.3467 2.048 1.04 2.784c.704.7253 1.584 1.088 2.64 1.088.5013 0 .976-.096 1.424-.288.4587-.192.8267-.416 1.104-.672v-1.664h-3.184v-1.648h5.056v4c-1.1627 1.2907-2.6293 1.936-4.4 1.936z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.864 44.92h-1.68v-.832c-.5973.6827-1.4293 1.024-2.496 1.024-.704 0-1.328-.224-1.872-.672-.544-.4587-.816-1.088-.816-1.888 0-.8213.2667-1.4453.8-1.872.544-.4267 1.1733-.64 1.888-.64 1.0987 0 1.9307.3307 2.496.992v-1.152c0-.448-.1653-.8-.496-1.056s-.768-.384-1.312-.384c-.864 0-1.6267.3253-2.288.976l-.688-1.168c.8747-.832 1.9573-1.248 3.248-1.248.9493 0 1.7227.224 2.32.672s.896 1.1573.896 2.128zm-3.52-.96c.8427 0 1.456-.2667 1.84-.8v-1.168c-.384-.5333-.9973-.8-1.84-.8-.48 0-.8747.128-1.184.384s-.464.592-.464 1.008.1547.752.464 1.008c.3093.2453.704.368 1.184.368z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrbanAgent);
export default __webpack_public_path__ + "static/media/urban-agent.c9c4d86a.svg";
export { ForwardRef as ReactComponent };